var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tabs',[_vm._l((_vm.tabs),function(tab){return _c('v-tab',{key:tab.id,attrs:{"to":tab.route}},[_vm._v(" "+_vm._s(tab.name)+" ")])}),_c('v-tab-item',[_c('router-view')],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }